import NicknameBar from '../components/NicknameBar';

interface BondWaitingScreenProps {
  message: string;
}

function BondWaitingScreen({ message }: BondWaitingScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 pt-10">
      <NicknameBar />
      <div className="text-center">
        <div className="text-6xl mb-6 animate-pulse">🔗</div>
        <p className="text-xl font-heading text-ink">{message}</p>
      </div>
    </div>
  );
}

export default BondWaitingScreen;
